import { Button, Drawer, Space } from "antd";
import { useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { BsCheckSquare } from "react-icons/bs";
import Moment from "react-moment";
import ConfirmPanel from "./ConfirmPanel";
import { formatNumber } from "../../../../utils/formatNumber";

export default function BookingPanel({
  setVisible,
  isVisible,
  selected,
  refetch,
}: any) {
  const [confirmModal, setConfirmModal] = useState(false);
  return (
    <Drawer
      title={`${selected?.extendedProps?.vehicle} BOOKING`}
      placement={"right"}
      width={800}
      onClose={() => setVisible(!isVisible)}
      visible={isVisible}
      closable={false}
      extra={
        <Space className="flex justify-center items-center">
          <Button
            type="default"
            color="#E50000"
            onClick={() => setVisible(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <div className="flex flex-col">
        <div className="flex text-black font-bold text-lg">
          VEHICLE:
          {selected?.title ? selected?.title : selected?.extendedProps?.vehicle}
        </div>
        <div className="flex">
          <div className="flex">
            <div>
              <div className="mb-4">
                <span className="font-bold mt-2">Customer Details: </span>
                <div className="flex">
                  <div className="flex flex-col ml-2">
                    <span>
                      - Name: {selected?.extendedProps?.customer_name}
                    </span>
                    <span>
                      - Mobile: {selected?.extendedProps?.customer_mobile}
                    </span>
                    <span>
                      - Email: {selected?.extendedProps?.customer_email}
                    </span>
                    <span>
                      - Address: {selected?.extendedProps?.customer_address}
                    </span>
                    <span>
                      - Account: {selected?.extendedProps?.customer_id}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mx-2">
            <div className="flex text-black font-bold text-sm">
              Vehicle Details : -
            </div>

            <div className="">
              <span className="">Type : </span>
              {selected?.extendedProps?.description}
            </div>

            <div className="">
              <span className="">Model : </span>
              {selected?.extendedProps?.model}
            </div>
            <div className="">
              <span className="">VIN : </span>
              {selected?.extendedProps?.vehicle_vin}
            </div>
            <div className="">
              <span className="">Engine No : </span>
              {selected?.extendedProps?.vehicle_engine}
            </div>
            <div className="">
              <span className="">Mileage : </span>
              <span className="text-gray-700">
                {selected?.extendedProps?.mileage === null ||
                selected?.extendedProps?.mileage === ""
                  ? "-"
                  : formatNumber(Number(selected?.extendedProps?.mileage))}{" "}
                Km
              </span>
            </div>
          </div>
          <div className="mx-2">
            <div className="flex text-black font-bold text-sm">
              Booking Details : -
            </div>
            <div className="ml-2">
              <span className="">- Requested : </span>
              <Moment format="Do MMM, YYYY">
                {selected?.extendedProps?.createdAt}
              </Moment>
            </div>
            <div className="flex ml-2">
              <span className="w-16">- Center : </span>
              {selected?.extendedProps?.site?.name}
            </div>
            <div className="flex ml-2">
              <span className="w-16">- Date: </span>
              <Moment format="Do MMM, YYYY">{selected?.date}</Moment>
            </div>
            <div className="flex ml-2">
              <span className="w-16">- Time : </span>
              <Moment format="HH:mm A">
                {selected?.extendedProps?.slottime?.starttime}
              </Moment>
              <div className="mx-2">-</div>
              <Moment format="HH:mm A">
                {selected?.extendedProps?.slottime?.endtime}
              </Moment>
            </div>
          </div>
        </div>
        <div className="flex flex-col mt-2">
          <span className="italic"> Additional Remarks : </span>
          {selected?.extendedProps?.customer_comments ? (
            <div>{selected?.extendedProps?.customer_comments}</div>
          ) : (
            <div className="text-gray-500 py-2"> No Remarks</div>
          )}
        </div>

        <div className="mt-4">
          <div className="font-bold mb-2">Registartion Card </div>
          {selected?.extendedProps?.attachment ? (
            <div className="border p-1">
              <img src={`data:${selected?.extendedProps?.attachment}`} />
            </div>
          ) : (
            <div className="text-gray-500 py-1 pb-8">No Document</div>
          )}
        </div>

        <div className="border-t pt-4">
          {!selected?.extendedProps?.is_confirmed ? (
            <button
              onClick={() => {
                setConfirmModal(true);
              }}
              className="flex justify-center items-center text-red-700 border rounded-md p-2 bg-gray-100 hover:bg-gray-200 cursor-pointer"
            >
              <span className="ml-1">Unconfirmed </span>
            </button>
          ) : (
            <button className="flex justify-center items-center ml-1 text-green-700 border rounded-md p-2 bg-green-100 hover:bg-green-200 cursor-not-allowed">
              <BsCheckSquare /> <span className="ml-1">Confirmed</span>
            </button>
          )}
        </div>
        <ConfirmPanel
          selected={selected}
          isVisible={confirmModal}
          setConfirmModal={setConfirmModal}
          refetch={refetch}
        />
      </div>
    </Drawer>
  );
}
